import { render, staticRenderFns } from "./RealEstateEncode.vue?vue&type=template&id=4acf7a40"
import script from "./RealEstateEncode.vue?vue&type=script&lang=js"
export * from "./RealEstateEncode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports